import { __assign, __read } from "tslib";
export var setFieldMutator = function (_a, state) {
    var _b = __read(_a, 2), name = _b[0], data = _b[1];
    var field = state.fields[name];
    if (field) {
        field.data = __assign(__assign({}, field.data), data);
    }
};
